import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'twilio-video';
import Loading from './Loading';

export default class VideoCall extends React.Component {
  constructor(props) {
    super(props);
    this.state = { localProgress: true, remoteProgress: true, error: null, room: null };
    this.hangup = this.hangup.bind(this);
  }

  componentWillMount() {
    window.VideoCall = this;
    this.startCall();
  }

  async componentWillUnmount() {
    this.audio = new Audio(await import('../sounds/hangup.mp3'));
    this.audio.play();
    delete window.VideoCall;
  }

  startCall() {
    const locale = global.dictionaries.calling;

    const trackAdded = (track, local) => {
      if (this.callTerminated) return;
      const id = local ? 'local-media' : 'remote-media';
      console.log(id, 'trackAdded', track.kind);
      const newState = { [local ? 'localProgress' : 'remoteProgress']: false };
      this.setState(newState);
      document.getElementById(id).appendChild(track.attach());
    };
    const trackRemoved = (track) => {
      console.log('trackRemoved', track.kind);
      track.detach().forEach(element => element.remove());
    };
    const participantConnected = (participant, local) => {
      console.log(local ? 'Local' : 'Remote', 'Participant Added', participant.identity);
      participant.tracks.forEach(track => trackAdded(track, local));
      participant.on('trackAdded', track => trackAdded(track, local));
      participant.on('trackRemoved', trackRemoved);
    };
    const participantDisconnected = (participant) => {
      console.log('Participant Removed', participant.identity);
      participant.tracks.forEach(trackRemoved);
    };
    this.props.socket.emit('get-token', null, (token) => {
      const roomName = `${this.props.senderEmail}:${this.props.receiverEmail}`;
      this.roomSubscription = connect(token,
        { name: roomName, audio: true, video: { facingMode: 'user' } }).then((room) => {
        if (this.callTerminated) {
          room.disconnect();
          return;
        }
        console.log('Connected to Room:', roomName);
        this.setState({ room });
        // draw local user's media for self preview
        participantConnected(room.localParticipant, true);
        // If remote user is already in room, draw their video on screen
        room.participants.forEach(participant => participantConnected(participant, false));
        // When remote user joins, draw their video on screen
        room.on('participantConnected', participant => participantConnected(participant, false));
        // When remote user disconnects, remove remote participant
        room.on('participantDisconnected', (participant) => {
          console.log('Remote Participant Disconnected', participant.identity);
          this.setState({ error: `${this.props.remoteUserName} ${locale.connectionLost} :(` });
        });
        // When we are disconnected, stop capturing local video
        room.once('disconnected', () => {
          console.log('Disconnected from Room');
          participantDisconnected(room.localParticipant);
          room.participants.forEach(participantDisconnected);
          this.unmount();
        });
        return room;
      }, (error) => {
        console.log('Could not connect to Twilio Video Room', error);
        if (!this.callTerminated) {
          this.setState({ error: error.message, localProgress: false, remoteProgress: false });
        }
      });
    });
  }

  hangup() {
    this.props.socket.emit('hang-up', { email: this.props.remoteUserEmail });
    this.terminateCall();
  }

  terminateCall() {
    this.callTerminated = true;
    if (this.state.room) {
      this.state.room.disconnect();
    } else if (this.roomSubscription) {
      this.roomSubscription.cancel();
    }
    this.unmount();
  }

  unmount() {
    ReactDOM.unmountComponentAtNode(document.getElementById('videoCall'));
  }

  showRemoteVideo() {
    return (
      <div id="remote-media">
        {this.state.remoteProgress ? <Loading /> : ''}
      </div>
    );
  }

  showLocalVideo() {
    return (
      <div id="local-media">
        {this.state.localProgress ? <Loading /> : ''}
      </div>
    );
  }

  showError() {
    return this.state.error ? <div className="video-error">{this.state.error}</div> : '';
  }

  render() {
    const locale = global.dictionaries.calling;

    return (
      <div>
        <div className="modal is-active">
          <div className="modal-background" />
          <div className="modal-content set-width">
            <div className="video-panel">
              {this.showError()}
              {this.showRemoteVideo()}
              {this.showLocalVideo()}
              <div className="end-button has-text-centered">
                <button className="button is-danger" onClick={this.hangup}>
                  <span className="icon">
                    <i className="fa fa-phone" />
                  </span>
                  <span style={{ textTransform: 'capitalize' }}>{locale.end}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoCall.js